module.exports = __webpack_public_path__ + "images/project-archived-0dcb138e1008331536cd66c01a68e0c2.svg";